import type { SVGProps } from 'react';

const SvgSortingAsc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='20'
    viewBox='0 0 20 20'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M5.20801 7.20817L9.99967 2.4165L14.7913 7.20817H5.20801Z' fill='currentColor' />
    <path d='M14.7913 12.7915L9.99967 17.5832L5.20801 12.7915H14.7913Z' fill='#767676' />
  </svg>
);
export default SvgSortingAsc;
